exports.sentryApplicationKeys = {
  website: 'booksprout-website',
  authorApp: 'booksprout-author-app',
  reviewerApp: 'booksprout-reviewer-app'
}
